module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBold.ea121152.woff";